import {
    Box,
    List,
    ListItem,
    makeStyles,
    Theme,
    Typography,
} from '@material-ui/core';
import axios from 'axios';
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';
import {
    member as v_member,
    basic,
    Values,
    member,
    order as v_order,
    product as v_product,
    order,
    SNACKBAR_TIME,
} from '../../request/values';
import { TitleBackBar } from '../header/TitleBar';
import { COLORS } from '../Theme';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) => ({
    itemProcessing: {
        backgroundColor: `${COLORS.LIGHT_GREY}`,
    },
    list: {
        width: '86vw',
        height: '74.5vh',
        overflowY: 'auto',
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        ...theme.typography.h3,
        color: `${COLORS.BROWNISH_GREY}`,
        [theme.breakpoints.up('md')]: {
            width: '100%',
            height: '100%',
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(6),
        },
    },
    productItem: {
        borderRadius: 5,
        border: 'solid 1px #d3d3d3',
        marginBottom: '1.7vh',

        width: 'auto',
        margin: 0,
        paddingLeft: '2.5vw',
        paddingRight: '5vw',
        paddingTop: '2.2vh',
        paddingBottom: '2.2vh',

        '& #itemWrap': {
            width: '100%',
            display: 'flex',
            padding: '0',
            justifyContent: 'center',
            // alignItem: 'center',
        },
    },
    empty: {
        height: '62vh',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            width: '35vw',
            height: '35vw',
            [theme.breakpoints.up('md')]: {
                width: '25vw',
                height: '25vw',
            },
            marginBottom: '2.5vh',
            opacity: 0.4,
        },
        '& h1': {
            color: `${COLORS.DOWN}`,
        },
    },
    productDesc: {
        paddingLeft: '5vw',
        flexGrow: 1,
        '& #productName': {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            ...theme.typography.body1,
            color: `${COLORS.BROWNISH_GREY}`,
        },
        '& #productPrice': {
            ...theme.typography.subtitle2,
            color: `${COLORS.CHARCOAL_GREY}`,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
    },
    timeText: {
        ...theme.typography.h1,
        fontFamily: 'NanumR',
        fontWeight: 'normal',
        [theme.breakpoints.up('md')]: {
            ...theme.typography.h5,
            fontFamily: 'NanumR',
            fontWeight: 'normal',
        },
    },
}));

const ProductOrderList2: React.FC<any> = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { member } = props;

    const [product, setProduct] = useState<any>([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const count = 20;
    let max_count: number = 999;
    const loader = useRef(null);
    const [page, setPage] = useState(-count);

    const handleObserver = useCallback((entries: any) => {
        const target = entries[0];
        if (target.isIntersecting) {
            setPage((prevState) => {
                if (prevState + count > max_count) {
                    return prevState;
                }
                return prevState + count;
            });
        }
    }, []);

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: '20px',
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (loader.current) observer.observe(loader.current!);
    }, [handleObserver]);

    const AddComma = (num: number) => {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
    };

    const getProductOrderList = (position: number, count: number) => {
        let url = new URL(
            basic.server + v_member.member + v_product.decompose_order_list
        );
        let params = {
            companyNum: member.companyNum,
            position: position.toString(),
            count: count.toString(),
        };
        url.search = new URLSearchParams(params).toString();
        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);

                if (data.code === Values.SUCCESS_CODE) {
                    if (product.length === 0 && data.products.length === 0) {
                        enqueueSnackbar(ToastStr.PRODUCT_PURCHASE_EMPTY_STR, {
                            variant: 'success',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    } else if (data.products === null) {
                        enqueueSnackbar(ToastStr.PRODUCT_PURCHASE_EMPTY_STR, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    } else {
                        console.log(data.products);
                        if (product.length === 0) {
                            setProduct((prevState: any) => data.products);
                        } else {
                            setProduct((prevState: any) =>
                                prevState.concat(data.products)
                            );
                        }
                    }
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });
    };

    useEffect(() => {
        //console.log(page, count)
        if (page >= 0) {
            getProductOrderList(page, count);
        }
    }, [page]);

    return (
        <div className="contentSmallPdTop">
            <TitleBackBar
                history={history}
                title="제품 영수증"
                titleIcon="order"
            />

            <Box display="grid" justifyContent="center" alignItems="center">
                <List className={classes.list}>
                    {product.length !== 0 ? (
                        product.map((item: any, index: number) => {
                            return (
                                <ListItem
                                    className={classes.productItem}
                                    alignItems="center"
                                >
                                    <ProductItem
                                        {...item}
                                        AddComma={AddComma}
                                        member={member}
                                    />
                                </ListItem>
                            );
                        })
                    ) : (
                        <div className={classes.empty}>
                            <div>
                                <img src="/images/title/order.webp" />
                                <Typography variant="h1">
                                    제품 판매 내역이 없습니다.
                                </Typography>
                            </div>
                        </div>
                    )}
                    <div ref={loader} />
                </List>
            </Box>
        </div>
    );
};

const ProductItem: React.FC<any> = (props) => {
    const classes = useStyles();

    return (
        <div>
            <div id="itemWrap" style={{ alignItems: 'center' }} translate="no">
                <img
                    style={{ width: '23%' }}
                    src={
                        basic.server +
                        '/displayImage?fileName=' +
                        props.productImage
                    }
                />
                <div className={classes.productDesc}>
                    <Typography id="productName">{`Lv. ${props.productLicenseLevel} ${props.productName}`}</Typography>
                    <Typography id="productPrice">{`${props.AddComma(
                        props.productSalePrice
                    )}원`}</Typography>
                    <Typography id="companyName">{`판매 기업: ${props.companyName}`}</Typography>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Typography className={classes.timeText}>
                        {props.productSaleAppDate != null &&
                            props.productSaleAppDate.length >= 19 &&
                            props.productSaleAppDate.substring(10, 16)}
                    </Typography>
                    <Typography>구매완료</Typography>
                </div>
            </div>
        </div>
    );
};
export default ProductOrderList2;
